__turbopack_context__.v({
  "actionLink": "MobileMenu-module__PEiPha__actionLink",
  "actions": "MobileMenu-module__PEiPha__actions",
  "chapterLink": "MobileMenu-module__PEiPha__chapterLink",
  "chapterList": "MobileMenu-module__PEiPha__chapterList",
  "chapters": "MobileMenu-module__PEiPha__chapters",
  "cta": "MobileMenu-module__PEiPha__cta",
  "language": "MobileMenu-module__PEiPha__language",
  "linkList": "MobileMenu-module__PEiPha__linkList",
  "panel": "MobileMenu-module__PEiPha__panel",
  "panelOpen": "MobileMenu-module__PEiPha__panelOpen",
  "root": "MobileMenu-module__PEiPha__root",
  "trigger": "MobileMenu-module__PEiPha__trigger",
});
